<template>
    <div v-if="message" class="modal modal_is-open modal-msg">
        <div class="modal__main">
            <button @click="closeMessage" class="modal__close button-icon r-button" type="button">
                <span class="screen-reader">Закрыть окно</span>
            </button>
            <strong class="modal__title modal-msg__msg r-strong" v-html="message"></strong>
            <div class="modal-msg__actions">
                <form @submit.prevent="buttonAction">
                    <input :type="inputType" :min="inputType == 'number' ? 0 : ''" v-model="inputText" name="balance" required="required" class="field__input r-text-input">
                    <button class="modal-msg__action r-button button" type="submit">{{ buttonActionText }}</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        name: "PromptMessage",
        data() {
            return {
                message: this.text,
                buttonActionText: this.buttonAction,
                inputText: null,
                inputType: null,
            }
        },
        props: {
            text: {
                type: String
            },
            button: {
                type: String
            }
        },
        created() {
            window.PromptMessage = new Vue();

            PromptMessage.$on('messageShow', (text, firstOption, inputType) => {
                this.message = text;
                this.buttonActionText = firstOption;
                this.inputType = inputType;
            });
        },
        methods: {
            closeMessage() {
                this.message = false;

                PromptMessage.$emit('messageClose');
            },
            buttonAction() {
                this.message = false;

                PromptMessage.$emit('buttonAction', {input: this.inputText});
            },
        }
    }
</script>
